import React from 'react';
import { Button } from 'antd';

const ToggleSwitch = ({ 
  value = false, 
  onChange, 
  yesText = 'YES', 
  noText = 'NO',
  size = 'default',
  disabled = false,
  style = {}
}) => {
  const handleToggle = (newValue) => {
    if (!disabled && onChange) {
      onChange(newValue);
    }
  };

  const buttonStyle = {
    height: size === 'small' ? '28px' : size === 'large' ? '40px' : '32px',
    minWidth: size === 'small' ? '40px' : size === 'large' ? '60px' : '50px',
    fontSize: size === 'small' ? '12px' : size === 'large' ? '16px' : '14px',
    fontWeight: '500',
    border: '1px solid #d9d9d9',
    borderRadius: 0,
    transition: 'all 0.2s ease',
  };

  const activeStyle = {
    backgroundColor: '#1890ff',
    borderColor: '#1890ff',
    color: '#fff',
    zIndex: 1,
  };

  const inactiveStyle = {
    backgroundColor: '#fff',
    borderColor: '#d9d9d9',
    color: '#666',
  };

  const disabledStyle = {
    opacity: 0.6,
    cursor: 'not-allowed',
  };

  return (
    <div 
      style={{ 
        display: 'inline-flex', 
        borderRadius: '6px', 
        overflow: 'hidden',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        ...style 
      }}
    >
      <Button
        style={{
          ...buttonStyle,
          ...(!value ? activeStyle : inactiveStyle),
          borderTopLeftRadius: '6px',
          borderBottomLeftRadius: '6px',
          borderRight: 'none',
          ...(disabled ? disabledStyle : {})
        }}
        onClick={() => handleToggle(false)}
        disabled={disabled}
      >
        {noText}
      </Button>
      <Button
        style={{
          ...buttonStyle,
          ...(value ? activeStyle : inactiveStyle),
          borderTopRightRadius: '6px',
          borderBottomRightRadius: '6px',
          borderLeft: 'none',
          ...(disabled ? disabledStyle : {})
        }}
        onClick={() => handleToggle(true)}
        disabled={disabled}
      >
        {yesText}
      </Button>
    </div>
  );
};

export default ToggleSwitch;
